import { IResourceList } from 'src/components/challenge/ChallengeInterfaces';
import { ResourceTypeDetailEnum } from 'src/shared/enums';
import { IChallengeCheckoutBookingTimify } from 'src/shared/models/checkoutBookingTimify.model';

const {
  CHECKOUT_BOOKING_TIMIFY_BUTTON_TEXT,
  CHECKOUT_BOOKING_TIMIFY_TEXT,
  CHECKOUT_BOOKING_TIMIFY_ID,
} = ResourceTypeDetailEnum;

export const buildChallengeCheckoutBookingTimify = (
  resource: IResourceList
): IChallengeCheckoutBookingTimify => {
  const { resourceDetailList, idResource, name: title, score } = resource;
  let item: IChallengeCheckoutBookingTimify;
  resourceDetailList
    .filter(({ status }) => status)
    .forEach(({ idResourceTypeD: { idResourceTypeD }, value }) => {
      switch (idResourceTypeD) {
        case CHECKOUT_BOOKING_TIMIFY_BUTTON_TEXT:
          item = {
            ...item,
            buttonLabel: value,
          };
          break;
        case CHECKOUT_BOOKING_TIMIFY_TEXT:
          item = {
            ...item,
            text: value,
          };
          break;
        case CHECKOUT_BOOKING_TIMIFY_ID:
          item = {
            ...item,
            bookingId: value,
          };
          break;
        default:
          break;
      }
    });

  return {
    ...item,
    idResource,
    points: score?.points || 0,
    title,
  };
};
